import * as Yup from "yup"
export const validationstation = (state) => {
  let validationSchema = {}
  return validationSchema = Yup.object().shape({
    stationID: Yup.string().required("Enter Station ID"),
    name: Yup.string().required("Enter Station Name"),
    serialNumber: Yup.string().required("Enter Serial Number"),
    vendorName: Yup.string().required("Enter Vendor Name"),
    model: Yup.string().required("Enter Model"),
    address_line1: Yup.string()
      .max(30, "Must be 30 characters or less")
      .required("Enter Address 1"),
    address_line2: Yup.string()
      .max(30, "Must be 30 characters or less")
      .required("Enter Address 2"),
    // coordinates: Yup.object().shape({
    //   latitude: Yup.number().required("Enter Latitude"),
    //   longitude: Yup.number().required("Enter Longitude"),
    // }),
  });
}
